'use client';
import RightBanner from './RightBanner';
import AccessInformation from './AccessInformation';
import LinkPage from './LinkPage';

const Sidebar = ({ rightBanners, linkPages, websiteCode }) => {
  return (
    <div className={`space-y-2 mb-4`}>
      <RightBanner rightBanners={rightBanners} />
      <LinkPage linkPages={linkPages} />
      <AccessInformation websiteCode={websiteCode} />
    </div>
  );
};

export default Sidebar;
